if (!customElements.get("complementary-recommendations")) {
  class ComplementaryRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) {
          return;
        }

        observer.unobserve(this);
        this.loadRecommendations(this.dataset.url, this.dataset.urlFallback);
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }

    // Tente d'abord les produits complémentaires curés manuellement (Search & Discovery).
    // Si aucun n'est défini, bascule sur les produits liés (intent=related, algorithmique)
    // pour garantir un bloc jamais vide.
    loadRecommendations(url, fallbackUrl) {
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("complementary-recommendations");

          if (recommendations && recommendations.querySelector(".card")) {
            this.innerHTML = recommendations.innerHTML;
            this.classList.add("product-recommendations-loaded");
          } else if (fallbackUrl) {
            this.loadRecommendations(fallbackUrl, null);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  customElements.define("complementary-recommendations", ComplementaryRecommendations);
}
